import { delFts, get, getFile, post, postImage } from "api/apiBridges/httpBridge";
import { useCallback, useContext, useEffect, useState, useMemo } from "react";
import Button from '@mui/material/Button';
import { Avatar, Box, Collapse, Dialog, Divider, List, ListItemButton, ListItemText, MenuItem, Modal, Paper, Select, Switch, TextField, Typography } from "@mui/material";
import { modal_style } from "styles/modal_style"
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { colors } from "styles/colors";
import { RadioDropList } from "components/RadioDropList";
import Carousel from "react-material-ui-carousel";
import Scrollbars from "rc-scrollbars";
import { DropdownMenu, ImagesCorusel, NumInput, TextFeature, TextInput, TextInputDesign, NumInputDesign } from "./LittleComponents";
import { useDispatch, useSelector } from "react-redux";
import { loginSelector } from "store/slices/loginSlice";
import _ from "lodash";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useLocalNotifications } from "components/Events";
import { setState } from "store/slices/dealTab";
import useOn from "components/socketLib/UseOn";
import { onChangeUploadImage } from "store/slices/uploadImage";
import { SocketContext } from "components/socketLib/ConnectorSocket";
import UserAvatar from "./UserAvatar";
import { DateMenu} from 'components/RangeDate';
import Loading from 'components/Load';
import usePreventDoubleClick from "components/AntiDBC";
import MuiInput from '@mui/material/Input';
import handleConfirm from "components/AlertMessage";
import { MemoTextField } from "components/MemoTextField";
import AdminList from "components/AdminList";

export default function Deal({ds, deal_id, setChanged, reload = undefined}){

  const [loading, setLoading] = useState(true);
  /** @type {[any, Function]} */
  const [statuses, setStatuses] = useState([]);
  const [addrSettingsOpen, setAddrSettingsOpen] = useState(false);
    /** @type {[any, Function]} */
  const [openGallery, setOpenGallery] = useState(undefined);
  /** @type {[any, Function]} */
  const [data, setData] = useState({});
  /** @type {[any, Function]} */
  const [managersList, setManagersList] = useState([]);

  const { company_id, user_id, rules } = useSelector(
          loginSelector
        );
  const dispatch = useDispatch();
  console.log("dealID", deal_id)
  

  // Функция для изменения значений полей
  const handleInputChange = (val, path) => {
    let tmp = JSON.parse(JSON.stringify(data))
    let subpathes = path.split('.')
    let cp = ""
    for (let p of subpathes) {
      cp += p
      if (!_.get(tmp, cp)) {_.set(tmp, cp, {})}
      cp += '.'
    }
    _.set(tmp, path, val)
    setData(tmp);
    if (setChanged) setChanged(true); 
  };


  const { showNotification } = useLocalNotifications();

  const handleClickSave = async () => {
    console.log("SAVE")
    let tmp = JSON.parse(JSON.stringify(data))

    delete tmp.user
    delete tmp.manager

    await post("Deal/update", {...tmp, user_id})
    socket.emit("init_actualization_deals", {id:deal_id, company_id, type: data.type})
    
    if (setChanged) setChanged(false);

    showNotification({
      id: 'test', // Уникальный идентификатор
      type: 'success', // Тип уведомления
      message: 'Данные сохранены' // Текст сообщения
    });

    // console.log('SAVED DATA', tmp)
  }

  const checkStatusRule = (id) => {
    if (rules.includes("admin")) {return true}
    switch (id) {
      case "pik_goods": 
        return rules.includes("main.pick_product")
      case "moving_deals":
        return rules.includes("main.move_product")
      case "products_storage":
        return rules.includes("main.storage_product")
      case "products_shipment":
        return rules.includes("main.shipment_product")
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [responseData, managers] = await Promise.all([
          get('Deal/getMore', {did: deal_id}),
          get("Admins/getOnCompanyALL", {cid: company_id})
        ])

        if (Array.isArray(managers)) {setManagersList(managers)}

        console.log("responseData", responseData)
        //Загрузка картинок 
        let tmp = []
        if (responseData?.data?.acceptance?.images) {
          await Promise.all(responseData.data.acceptance.images.map(async (el) => {
            let img = await getFile("png", {path:el})
            tmp.push({src:img, path:el})
          }))
          responseData.data.acceptance.images = tmp
        }
        tmp = []
        if (responseData?.data?.packaging?.images) {
          await Promise.all(responseData.data.packaging.images.map(async (el) => {
            let img = await getFile("png", {path:el})
            tmp.push({src:img, path:el})
          }))
          responseData.data.packaging.images = tmp
        }
        
        setData(responseData)        

      } catch (err) { console.log("err", err)
      } finally {
        setLoading(false);
      }
    };
    const fetchStatuses = async () => {
      try {
        if(ds.descr.statuses) {
          let res = [...ds.descr.statuses]
          
          let result = []
          let index = 0
          for (let st of res) {
            if (checkStatusRule(st.id)) {
              res[index].list = await get('dndTables/get', {cid:company_id, type: st.id})
              result.push(res[index])
            }
            index += 1
          }
          setStatuses(result)
        }

      } catch (err) {
      } finally {
        setLoading(false);
      }
    };
    fetchData()
    fetchStatuses()
  }, [deal_id]);
  

  useOn('uploadDealImage', async (indata) => {
    console.log("uploadDealImage", indata);
    let photo = await getFile("png", {path:indata.path});
    
    if (photo) {

        let tmp = JSON.parse(JSON.stringify(data))
        if (!_.get(tmp, indata.dataPath)) {_.set(tmp, indata.dataPath, {images: []})}
        let tmpImage = _.get(tmp, indata.dataPath).images || []
        tmpImage.push({src:photo, path:indata.path});
        let forUpdate  = JSON.parse(JSON.stringify(tmp))
        _.set(tmp, `${indata.dataPath}.images`, tmpImage)
        _.set(forUpdate, `${indata.dataPath}.images`, tmpImage.map((el) => el.path))
        
        await post("Deal/update", {...forUpdate, user_id});

        setData(tmp);

        showNotification({
          id: 'test', 
          type: 'success', 
          message: 'Данные сохранены' 
        });
    }
  });
  
    const { socket } = useContext(SocketContext);
    const onSubmit = useCallback((data) => {
        dispatch(onChangeUploadImage(data));
    }, [dispatch]);
  
    const handleFileUpload = async (event, dataPath) => {
      console.log('dataPath',dataPath )
        let selectedFiles = Array.from(event.target.files);
        if (selectedFiles) {
          let rightFiles = []
          selectedFiles.map((file) => {
            if (file.type === "image/png" || file.type === "image/jpeg") {
              rightFiles.push(file)
            }
            else {
              showNotification({
                id: 'uploadDealImageErr', // Уникальный идентификатор
                type: 'error', // Тип уведомления
                message: `Файл ${file.name} неподдерживаемого типа` // Текст сообщения
              });
            }  
          })
          if (rightFiles.length > 0) {
            onSubmit({ upload: true });
            showNotification({
              id: 'uploadDealImage', // Уникальный идентификатор
              type: 'info', // Тип уведомления
              message: 'Загрузка' // Текст сообщения
            });
            postImage(rightFiles, socket.id, {user_id:deal_id, role:`deal`, content_type:"uploadDealImage", dataPath}).then(() => { selectedFiles = []; onSubmit({ upload: false });});
          }
        }
    }

    const handleFileDel = async (index, dataPath) => {
      console.log(index)
      let tmp = JSON.parse(JSON.stringify(data))
      let old = _.get(tmp, dataPath).images
      let deleted = old.splice(index, 1)
      _.set(tmp, dataPath+".images", old )
      await delFts('/delete-file', {path:[deleted[0].path], taskType: "delImage"}, socket.id)
      
      let forUpdate  = JSON.parse(JSON.stringify(tmp))
      _.set(forUpdate, dataPath+".images", _.get(forUpdate, dataPath+".images").map((el) => el.path))
      await post("Deal/update", {...tmp, user_id})
      
      setData(tmp)      
    }


    const onChangeStatus = async (type, status) => {
      let newTypeTitle = undefined
      let newStatusTitle = undefined
      let showStatus = undefined
      
      if (type === 'products_storage') {
        const [bind, defect] = await Promise.all([
          get("Deal/checkBind", {did: deal_id}),
          get("Deal/checkDefect", {did: deal_id}),
        ])
        if (!bind.all_bind) {
          showNotification({
            id: 'dontcanToStorageNeedBind', // Уникальный идентификатор
            type: 'warning', // Тип уведомления
            message: 'Не весь товар распределен по коробам' // Текст сообщения
          });
          return 
        }
        if (!defect.no_defect) {
          showNotification({
            id: 'dontcanToStorageNeedDelDefect', // Уникальный идентификатор
            type: 'warning', // Тип уведомления
            message: 'Не весь брак перемещен на хранение' // Текст сообщения
          });
          return 
        }
      }

      let idx = statuses.findIndex((fel) => fel.id === type)
      if (idx > -1) {
        newTypeTitle = statuses[idx].groupname
        let idx2 = statuses[idx].list.findIndex((fel) => fel.status === status)
        if (idx2 > -1) {
          newStatusTitle = statuses[idx].list[idx2].name
          if (statuses[idx].list[idx2].showStatus)
            showStatus = statuses[idx].list[idx2].name
        }
      }

      let oldTypeTitle = data.type
      let oldStatusTitle = data.status
      let oldIdx = statuses.findIndex((fel) => fel.id === data.type)
      if (oldIdx > -1) {
        oldTypeTitle = statuses[oldIdx].groupname
        let oldIdx2 = statuses[oldIdx].list.findIndex((fel) => fel.status === data.status)
        if (oldIdx2 > -1) {
          oldStatusTitle = statuses[oldIdx].list[oldIdx2].name
        }
      }

      socket.emit("dnd_change_deal_type", {id: deal_id, newStatus: status, oldType: data.type, newType: type, company_id, showStatus})
      post("Logs/create", {
        deal_id,
        user_type: "ful",
        user_id,
        type: "change_deal_status",
        data: {
          oldType: oldTypeTitle,
          oldStatus: oldStatusTitle,
          newType: newTypeTitle || type,
          newStatus: newStatusTitle || status
        }
      })

      let temp = JSON.parse(JSON.stringify(data))
      temp.status = status
      temp.type = type
      setData(temp)
      showNotification({
        id: 'successChangeStatus', // Уникальный идентификатор
        type: 'success', // Тип уведомления
        message: 'Статус сделки успешно изменен' // Текст сообщения
      });
      // @ts-ignore
      if (reload) reload()
    }

  const closeDeal = () => {
    console.log('CLOSE START')
    const closeDealOk = async (isOk) => {
        if (isOk) {

          console.log('CLOSE IS OK')

          let oldTypeTitle = data.type
          let oldStatusTitle = data.status
          let oldIdx = statuses.findIndex((fel) => fel.id === data.type)
          if (oldIdx > -1) {
            oldTypeTitle = statuses[oldIdx].groupname
            let oldIdx2 = statuses[oldIdx].list.findIndex((fel) => fel.status === data.status)
            if (oldIdx2 > -1) {
              oldStatusTitle = statuses[oldIdx].list[oldIdx2].name
            }
          }

          try {
            console.log('CLOSE TRY')
            await post("Logs/create", {
                deal_id,
                user_type: "ful",
                user_id,
                type: "close_deal",
                data:{}
            });

            socket.emit("dnd_close_deal", {id: deal_id, newStatus: 0, oldType: data.type, newType: 'archive', company_id});

            let temp = JSON.parse(JSON.stringify(data))
            temp.status = 0;
            temp.type = 'archive';
            setData(temp);
            // @ts-ignore
            if (reload) reload()

        } catch (error) {
            console.error(error);
        }
        }
    }

    handleConfirm('Вы уверены, что хотите завершить сделку?', closeDealOk);
  }

  const checkRoles = (role) => {
    if (rules.includes("admin")) {return true}
    switch (role) {
      case "pickProduct": 
        return rules.includes("deal.pick_product")
      case "acceptance":
        return rules.includes("deal.acceptance")
      case "sort":
        return rules.includes("deal.sort")
      case "logistic":
        return rules.includes("deal.logistic")
      case "package":
        return rules.includes("deal.package")
      case "pricing":
        return rules.includes("deal.pricing")
    }
  }

  console.log("data", data)

  if (loading || !data.id) {
    return (<Loading></Loading>);
  }
  

  
  return (
    <div style={{height: "100%"}}>
      <Dialog
        open={addrSettingsOpen}
        maxWidth='lg'
        PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
        onClose={() => { setAddrSettingsOpen(false) }}
      >
        <div style={{ height: '620px', width: '1000px', padding: '12px', }}>
            <AddrSettings deal_id = {deal_id} cancel={setAddrSettingsOpen}></AddrSettings>
        </div>

      </Dialog>
      <Dialog
        open={openGallery !== undefined}
        maxWidth={false}
        PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
        onClose={() => { setOpenGallery(undefined) }}
      >
        <div style={{ height: '500px', width: '500px', padding: '12px', }}>
            <ImagesCorusel key={openGallery} items={openGallery === 'cim'? data?.data?.acceptance?.images || []: data?.data?.packaging?.images || []} onChangeList={(e) => {handleFileUpload(e, openGallery === 'cim'? "data.acceptance": "data.packaging")}} onDel={(ind) => handleFileDel(ind, openGallery === 'cim'?"data.acceptance":"data.packaging")}/>
        </div>

      </Dialog>
      {
          ds.descr.statuses &&
          <div style={{height: "5%", width:"95%", margin: "0px 2% 0px 3%", padding: "10px 0 10px 0"}}>
              <Box>
                <RadioDropList list={statuses} $selected={{id:data.type, val:data.status}} onChangeStatus={onChangeStatus}/>
              </Box>
          </div>
      }
      <div style={{
        height: ds.descr.statuses? "95%": "100%",
        display: "flex",
        flexDirection: "column"
      }}>
        <Scrollbars
          autoHide
          style={{display: 'flex', justifyContent: "flex-start", flexDirection: "column", height: "85%"}}  
        >
          {/* Секция пользователя */}
          <Box mb={2} margin={"5px"} padding={"5px"} marginLeft={'15px'}>
            <Typography variant="h2" sx={{ color: '#208f84', textTransform: 'uppercase', mb: "10px"}}>
                Основное
            </Typography>
            <Box sx={{width: "98%", display: 'flex', flexDirection: 'column', marginLeft: "2%", gap: "7px"}}>
              <div style={{width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                <Typography variant="body1" style={{ marginRight: 10, width: "auto"}}>
                  Ответственный:
                </Typography>
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                  <Typography variant="body1" sx={{ mr: "10px", color: 'black'}}>
                    {data.manager.fio}
                  </Typography>
                  <UserAvatar 
                    src={data.manager.avatarUrl} 
                    userData={data.manager} 
                    user_id={data.manager.userId} 
                    size={25}
                  />
                </div>
              </div>
              <TextInputDesign
                title = 'Телефон:'
                val={data.user.phone} 
                onChange={() => {}}  
                align="right"
                editable={false}
              />

              <NumInputDesign
                title = 'Бюджет'
                val={data.user.budjet} 
                onChange={(e) => handleInputChange(e, 'user.budjet')}  
                align="right"
              />

              <TextInputDesign
                title = 'Канал привлечения:'
                val={data.user.clientSource} 
                onChange={(e) => handleInputChange(e, 'user.clientSource')}  
                align="right"
              />
            </Box>
          </Box>
          <div style={{ marginTop: '10px', width: '100%' }}>
            <Divider orientation="horizontal" sx={{borderBottomWidth: "10px", borderColor: "#e3e3e3"}} />
          </div>

          {/* Комментарий */}
          <Box sx={{width: "96%", margin: "2% 0% 2% 3%"}}>
            <MemoTextField             
                text={data?.data?.comment} 
                handleInputChange={(v) => handleInputChange(v, 'data.comment')}
                placeholder={"Комментарий к сделке"}
                maxLength={1000} 
                editable={true} 
                rows={5}
            />
          </Box>
          <div style={{ marginTop: '10px', width: '100%' }}>
            <Divider orientation="horizontal" sx={{borderBottomWidth: "10px", borderColor: "#e3e3e3"}} />
          </div>

          {/* Секция забор товара */}
          {
            checkRoles("pickProduct") &&
            <>  
              <Box mb={2} margin={"5px"} padding={"5px"} marginLeft={'20px'}>
                <Typography variant="h2" sx={{ color: '#208f84', textTransform: 'uppercase', mb: "10px" }}>
                  Забор товара
                </Typography>

                <Box sx={{width: "98%", display: 'flex', flexDirection: 'column', marginLeft: "2%", gap: "7px"}}>
                  <TextInputDesign
                    title = 'Объем в работу:'
                    val={data?.data?.pickup?.volume} 
                    onChange={() => {}}  
                    align="right"
                    editable={false}
                  />

                  <TextInputDesign
                    title = 'Контакты:'
                    val={data?.data?.pickup?.contact} 
                    onChange={(e) => handleInputChange(e, 'data.pickup.phone')}  
                    align="right"
                  />

                  <TextInputDesign
                    title = 'Подписание груза:'
                    val={data?.data?.pickup?.sign} 
                    onChange={(e) => handleInputChange(e, 'data.pickup.sign')} 
                    align="right"
                  />

                  <Box sx={{width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                    <Typography style={{ fontSize: "12pt" }}>
                      Дата поступления:
                    </Typography>
                    <DateMenu
                      date={data?.data?.logistic?.pickupDate ? new Date(data.data.logistic.pickupDate) : undefined} 
                      onChange={(val) => handleInputChange(val, 'data.logistic.pickupDate')}
                      bgColor="#bddcde" 
                      textColor="#747474"
                      
                    />
                  </Box>

                  <div style={{display: 'flex', flexDirection: "row", justifyContent: 'flex-end'}}>
                    <Button
                      onClick={() => {setAddrSettingsOpen(true)}}
                      variant="contained" 
                      disableElevation
                      sx={{
                        backgroundColor: '#bddcde',
                        borderRadius: '24px',
                        color: '#747474',
                        textTransform: 'none',
                        height: '26px',                        
                        '&:hover': {
                          backgroundColor: '#a5cdd0',
                        }
                      }} 
                    >
                      Адрес хранения
                    </Button>
                  </div>

                </Box>
              </Box>
              <div style={{ marginTop: '10px', width: '100%' }}>
                  <Divider orientation="horizontal" sx={{borderBottomWidth: "10px", borderColor: "#e3e3e3"}} />
              </div>
            </>
          }
          {/* Секция Приемка */}
          {
            checkRoles("acceptance") &&
            <>
              <Box mb={2} margin={"5px"} padding={"5px"} marginLeft={'20px'}>
                <Typography variant="h2" sx={{ color: '#208f84', textTransform: 'uppercase', mb: "10px" }}>
                  Приемка
                </Typography>
                <Box sx={{width: "98%", display: 'flex', flexDirection: 'column', marginLeft: "2%", gap: "7px"}}>

                  <Box sx={{width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                    <Typography style={{ fontSize: "12pt" }}>
                      Грузчик: 
                    </Typography>
                    <AdminList
                      list={managersList}
                      selected={managersList.find((fel) => data?.data?.acceptance?.loader === fel.id) || undefined}
                      onSelect={(v) => handleInputChange(v.id, 'data.acceptance.loader')}
                    />
                  </Box>

                  <TextInputDesign
                    title = 'Тип места:'
                    val={data?.data?.acceptance?.placeType} 
                    onChange={(e) => handleInputChange(e, 'data.acceptance.placeType')}
                    align="right"
                  />

                  <NumInputDesign
                    title = 'Количество мест'
                    val={data?.data?.acceptance?.placeCount} 
                    onChange={(e) => handleInputChange(e, 'data.acceptance.placeCount')}
                    align="right"
                  />

                  <div style={{display: 'flex', flexDirection: "row", justifyContent: 'space-between'}}>
                    <Button
                      onClick={() => {setOpenGallery("cim")}}
                      variant="contained" 
                      disableElevation
                      sx={{
                        backgroundColor: '#bddcde',
                        borderRadius: '24px',
                        color: '#747474',
                        textTransform: 'none',
                        height: '26px',                        
                        '&:hover': {
                          backgroundColor: '#a5cdd0',
                        }
                      }} 
                    >
                      Галерея
                    </Button>
                    <Button
                      onClick={() => {setAddrSettingsOpen(true)}}
                      variant="contained" 
                      disableElevation
                      sx={{
                        backgroundColor: '#bddcde',
                        borderRadius: '24px',
                        color: '#747474',
                        textTransform: 'none',
                        height: '26px',                        
                        '&:hover': {
                          backgroundColor: '#a5cdd0',
                        }
                      }} 
                    >
                      Адрес хранения
                    </Button>
                  </div>

                  {/* <div style={{width: "100%", display: 'flex', flexDirection: 'row'}}>
                    <div style={{width: "50%"}}>
                      <ImagesCorusel key={"cim"} items={data?.data?.acceptance?.images || []} onChangeList={(e) => {handleFileUpload(e, "data.acceptance")}} onDel={(ind) => handleFileDel(ind, "data.acceptance")}/>
                    </div>
                    
                  </div> */}

                </Box>


              </Box>
              <div style={{ marginTop: '10px', width: '100%' }}>
                  <Divider orientation="horizontal" sx={{borderBottomWidth: "10px", borderColor: "#e3e3e3"}} />
              </div>
            </>
          }
          {/* Секция сортировки */}
          {
            checkRoles("sort") &&
            <>
              <Box mb={2} margin={"5px"} padding={"5px"} marginLeft={'20px'}>
                <Typography variant="h2" sx={{ color: '#208f84', textTransform: 'uppercase', mb: "10px" }}>
                  Сортировка
                </Typography>
                <Box sx={{width: "98%", display: 'flex', flexDirection: 'column', marginLeft: "2%", gap: "7px"}}>

                  <TextInputDesign
                    title = 'SKU:'
                    val={data?.data?.sku}
                    onChange={(e) => {}}
                    align="right"
                    editable={false}
                  />

                  <TextInputDesign
                    title = 'Товара:'
                    val={data?.data?.units}
                    onChange={(e) => {}}
                    align="right"
                    editable={false}
                  />


                  <Box sx={{width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                    <Typography style={{ fontSize: "12pt" }}>
                      Сортировщик:
                    </Typography>
                    <AdminList
                      list={managersList}
                      selected={managersList.find((fel) => data?.data?.sort?.sorter === fel.id) || undefined}
                      onSelect={(v) => handleInputChange(v.id, 'data.sort.sorter')}
                    />
                  </Box>

                  <Box sx={{width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                    <Typography style={{ fontSize: "12pt" }}>
                      Начало сортировки:
                    </Typography>
                    <DateMenu
                      date={data?.data?.sort?.startDate ? new Date(data.data.sort.startDate) : undefined} 
                      onChange={(val) => handleInputChange(val, 'data.sort.startDate')}
                      bgColor="#bddcde" 
                      textColor="#747474"
                    />
                  </Box>

                  <Box sx={{width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                    <Typography style={{ fontSize: "12pt" }}>
                      Окончание сортировки:
                    </Typography>
                    <DateMenu
                      date={data?.data?.sort?.finishDate ? new Date(data.data.sort.finishDate) : undefined} 
                      onChange={(val) => handleInputChange(val, 'data.sort.finishDate')}
                      bgColor="#bddcde" 
                      textColor="#747474" 
                    />
                  </Box>

                </Box>
              </Box>
              <div style={{ marginTop: '10px', width: '100%' }}>
                  <Divider orientation="horizontal" sx={{borderBottomWidth: "10px", borderColor: "#e3e3e3"}} />
              </div>
            </>
          }
          {/* Секция упаковки */}
          {
            checkRoles("package") &&
            <>
              <Box mb={2} margin={"5px"} padding={"5px"} marginLeft={'20px'}>
                <Typography variant="h2" sx={{ color: '#208f84', textTransform: 'uppercase', mb: "10px" }}>
                  Упаковка
                </Typography>
                <Box sx={{width: "98%", display: 'flex', flexDirection: 'column', marginLeft: "2%", gap: "7px"}}>
                  
                  <Box sx={{width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                    <Typography style={{ fontSize: "12pt" }}>
                      Упаковщик:
                    </Typography>
                    <AdminList
                      list={managersList}
                      selected={managersList.find((fel) => data?.data?.packaging?.packager === fel.id) || undefined}
                      onSelect={(v) => handleInputChange(v.id, 'data.packaging.packager')}
                    />
                  </Box>

                  <Box sx={{width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                    <Typography style={{ fontSize: "12pt" }}>
                      Начало упаковки:
                    </Typography>
                    <DateMenu
                      date={data?.data?.packaging?.startDate ? new Date(data.data.packaging.startDate) : undefined} 
                      onChange={(val) => handleInputChange(val, 'data.packaging.startDate')}
                      bgColor="#bddcde" 
                      textColor="#747474"
                    />
                  </Box>

                  <Box sx={{width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                    <Typography style={{ fontSize: "12pt" }}>
                      Окончание упаковки:
                    </Typography>
                    <DateMenu
                      date={data?.data?.packaging?.finishDate ? new Date(data.data.packaging.finishDate) : undefined} 
                      onChange={(val) => handleInputChange(val, 'data.packaging.finishDate')}
                      bgColor="#bddcde" 
                      textColor="#747474"
                    />
                  </Box>

                  <div style={{display: 'flex', flexDirection: "row", justifyContent: 'space-between'}}>
                    <Button
                      onClick={() => {setOpenGallery("pim")}}
                      variant="contained" 
                      disableElevation
                      sx={{
                        backgroundColor: '#bddcde',
                        borderRadius: '24px',
                        color: '#747474',
                        textTransform: 'none',
                        height: '26px',                        
                        '&:hover': {
                          backgroundColor: '#a5cdd0',
                        }
                      }} 
                    >
                      Галерея
                    </Button>
                    <Button
                      onClick={() => {setAddrSettingsOpen(true)}}
                      variant="contained" 
                      disableElevation
                      sx={{
                        backgroundColor: '#bddcde',
                        borderRadius: '24px',
                        color: '#747474',
                        textTransform: 'none',
                        height: '26px',                        
                        '&:hover': {
                          backgroundColor: '#a5cdd0',
                        }
                      }} 
                    >
                      Адрес хранения
                    </Button>
                  </div>

                  {/* <div style={{width: "100%", display: 'flex', flexDirection: 'row'}}>
                    <div style={{width: "50%"}}>
                      <ImagesCorusel key={"pim"} items={data?.data?.packaging?.images || []} onChangeList={(e) => {handleFileUpload(e, "data.packaging")}} onDel={(ind) => handleFileDel(ind, "data.packaging")} />
                    </div>
                  </div>                */}

                </Box>
              </Box>
              <div style={{ marginTop: '10px', width: '100%' }}>
                  <Divider orientation="horizontal" sx={{ borderBottomWidth: "10px", borderColor: "#e3e3e3" }} />
              </div>
            </>
          }
          {/* Секция логистики */}
          {
            checkRoles('logistic') &&
            <>
              <Box mb={2} margin={"5px"} padding={"5px"} marginLeft={'20px'}>
                <Typography variant="h2" sx={{ color: '#208f84', textTransform: 'uppercase', mb: "10px" }}>
                  Логистика
                </Typography>
                <Box sx={{width: "98%", display: 'flex', flexDirection: 'column', marginLeft: "2%", gap: "7px"}}>

                  <TextInputDesign
                    title = 'Транзитный склад'
                    val={data?.warehouse_tranzit} 
                    onChange={(e) => handleInputChange(e, 'warehouse_tranzit')} 
                  />

                  <TextInputDesign
                    title = 'Склад назначения'
                    val={data?.warehouse_market} 
                    onChange={(e) => handleInputChange(e, 'warehouse_market')} 
                  />

                  <TextInputDesign
                    title = 'Тип отгрузки'
                    val={data?.data?.logistic?.type} 
                    onChange={(e) => handleInputChange(e, 'data.logistic.type')}
                  />

                  <NumInputDesign
                    title = 'Количество мест'
                    val={data?.data?.logistic?.placeCount} 
                    onChange={(e) => handleInputChange(e, 'data.logistic.placeCount')} 
                  />

                  <NumInputDesign
                    title = 'Количество ед.'
                    val={data?.data?.logistic?.itemCount} 
                    onChange={(e) => handleInputChange(e, 'data.logistic.itemCount')}  
                  />
                </Box>
              </Box>
              <div style={{ marginTop: '10px', width: '100%' }}>
                  <Divider orientation="horizontal" sx={{ borderBottomWidth: "10px", borderColor: "#e3e3e3" }} />
              </div>
            </>
          }
          <Box mb={2} margin={"5px"} padding={"5px"} marginLeft={'20px'} sx={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width: '95%'}}>
            <Button 
                onClick={closeDeal}    
                variant="contained" 
                sx={{ 
                    height: "35px", 
                    textTransform: 'none',  
                    fontSize: "18px",
                    borderRadius: "10px"
                }}
            >
                {"Завершить сделку"}
            </Button>
          </Box>
          
        </Scrollbars>
        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '98%', marginTop: "10px" }}>
            <Button 
              onClick={handleClickSave}
              variant="contained" 
              sx={{ 
                textTransform: 'none', 
                backgroundColor: colors.elements, 
                fontWeight: 'bold', 
                borderRadius: "10px"
              }} 
            >
              Применить
            </Button>
        </div>
      </div>
    </div>
  );
}

export function Additional_feature({type, val, name, title, onChange, values}) {
  switch (type) {
    case "fix":
    case "func":
      return <Typography variant="h4">{title}: {val}</Typography>
    case "input":
      return(
        <TextInput 
          title={title} 
          val={val}
          onChange={(e) => onChange(e)} 
        />
      )
    case "enum":
       return (
        <div style={{width: "48%", marginTop: 5, display:'flex', flexDirection:'row', justifyContent: 'flex-start', alignItems: "center"}}>
          <Typography variant="h4" >{title}</Typography>
          <Select
            style={{width:"100%"}}
            value={val}
            // label="Возможные значения"
            onChange={(e) => onChange(e)} 
          >
            {values? values.map((v) => {return(<MenuItem value={v.val}>{v.name} ({v.val})</MenuItem>)}): <></>}
          </Select>
        </div>
        )
  }
}

function AddrSettings({deal_id, cancel}) {

    const { showNotification } = useLocalNotifications();
    const preventDoubleClick = usePreventDoubleClick();
    const [loading, setLoading] = useState(false);
      /** @type {[Array<any>, Function]} */
    const [boxes, setBoxes] = useState([]);
      /** @type {[Array<any>, Function]} */
    const [addrs, setAddrs] = useState([]);
    const [addPalletCount, setAddPalletCount] = useState(1);
    const { user_id, company_id } = useSelector(
        loginSelector
    );
    
    const fetchData = useCallback(async () => {
      try {
          setLoading(true);
        
          let resboxes = await get("Boxes/GetOnDeal", {did:deal_id})
          
          resboxes = resboxes.sort((a, b) => (a.id < b.id ? -1 : b.id > a.id ? 1 : 0));
          setBoxes(resboxes)
          let tables = await get('dndTables/get', {cid:company_id, type: "adrr_storage"})
          tables.map((t) => {
              t.items.map((subt) => {
                subt.name = `${subt.status.replaceAll('_', '-')}`
              })
              t.items = t.items.sort((a, b) => parseInt(a.status.split('_')[1]) - parseInt(b.status.split('_')[1]))
          })
          tables = tables.sort((a, b) => {
            // Разделяем строку status на букву и число
            const [aLetter, aNumStr] = a.status.split('-');
            const [bLetter, bNumStr] = b.status.split('-');
            
            const aNum = parseInt(aNumStr, 10);
            const bNum = parseInt(bNumStr, 10);
            
            // Функция проверки, является ли буква русской (заглавные А-Я, включая Ё)
            const isRussian = (ch) => /[А-ЯЁ]/.test(ch);
            
            const aIsRussian = isRussian(aLetter);
            const bIsRussian = isRussian(bLetter);
            
            // Сначала сортируем по языку: русские раньше английских
            if (aIsRussian !== bIsRussian) {
              return aIsRussian ? -1 : 1;
            }
            
            // Если язык одинаковый — сортируем по букве
            if (aLetter !== bLetter) {
              return aLetter < bLetter ? -1 : 1;
            }
            
            // Если буквы одинаковые — сортируем по числу
            return aNum - bNum;
          });
          setAddrs(tables)
          
      }
      catch {}
      finally {setLoading(false);}
  }, []);
  
  useEffect(() => {
      fetchData();
  }, []);

    const goBind = async () => {
        
    }

    const { socket } = useContext(SocketContext);
    
    const handleInputChangeAddr = async (id, val) => {
        let tmp = JSON.parse(JSON.stringify(boxes))
        let idx = tmp.findIndex((fel) => fel.id === id)
        tmp[idx].addr = val
        await post('Boxes/update', {id, addr: val})
        socket.emit("dnd_change_addr", {id, type:'adrr_storage', company_id})
        setBoxes(tmp)
    };

    const addBox = async () => {
        setLoading(true)
        let res = []
        let $addBoxCount = addPalletCount
        for (let i = 1; i <= $addBoxCount; i++) {

            let BN = undefined
            let tmpboxex = JSON.parse(JSON.stringify(boxes)).filter((fel) => fel.type === "start_pallet")
            if (tmpboxex.length > 0) {
                let idx = tmpboxex.sort((a, b) => (a.id > b.id ? -1 : b.stocks < a.stocks ? 1 : 0))?.[0]?.title.lastIndexOf("P") || -1
                if (idx > -1) {
                    let s = tmpboxex[0].title.slice(idx+1)
                    BN = parseInt(s)+i
                }
                else {BN = 1}
            }
            else {
                BN = i
            } 

            let nb = await post("Boxes/create", {deal_id, title: `SP${BN}`, sku: 0, count:0, box_count:0, type:"start_pallet" , parent_id:undefined})
            res.push(nb.message)
        }   
        setBoxes(boxes.concat(res).sort((a, b) => (a.id < b.id ? -1 : b.id > a.id ? 1 : 0)))
        setLoading(false)
        return res
    }

    return (
        <Box
            sx={{
                height: '100%',
                display: "flex",
                flexDirection: "column",
                p: 1,
                gap: 2,
            }}
        >
            {/* Заголовок */}

            <Typography
                variant="h4"
                sx={{
                    fontWeight: "bold",
                    color: "text.primary",
                }}
            >
                Настройки адресного хранения
            </Typography>
            <div style={{width: "90%",display: 'flex', flexDirection: "row", justifyContent:'space-around'}}>
              <div style={{width: "40%", display: 'flex', flexDirection: 'column', alignItems: "center"}}>
                  <Typography
                    variant="body1"
                    sx={{
                        fontWeight: "bold",
                        color: "text.primary",
                    }}
                  >
                    Прием товара
                  </Typography>
                  <Scrollbars
                    style={{maxHeight: "480px", height: `${boxes.filter((fel) => fel.type === "start_pallet").length*60}px`}}
                  >
                    {boxes.filter((fel) => fel.type === "start_pallet").map((parel, index) => (
                      <>
                          <ListItemButton sx={{width: "100%", height: "60px"}}>
                              <div style={{ width: '100%', display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                  <div style={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                      {/* <ListItemText primary={el.id} /> */}
                                      <Typography variant='subtitle2' align='left' style={{ fontWeight: 'bold' }}>{parel.title}</Typography>
                                  </div>
                                  <div
                                      style={{display: 'flex', flexDirection: 'column'}}
                                  >
                                      <Typography sx={{lineHeight: "10px", fontSize: "10px", marginLeft:"10px"}}>Адрес хранения</Typography>
                                      <DropdownMenu 
                                          data={addrs} 
                                          onChange={(e) => handleInputChangeAddr(parel.id, e)}  
                                          startVal={parel.addr}
                                          defText={"Выбрать ячейку"}
                                      />
                                  </div>
                              </div>
                          </ListItemButton>
                      </>
                    ))}
                  </Scrollbars>
                  <div style={{width: '100%', marginTop: "5px", display: 'flex', flexDirection: 'row', justifyContent: "space-between"}}>
                    <div style={{width: "40%"}}></div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "flex-end"}}>
                        <MuiInput
                            sx={{ ':after': { borderBottomColor: '#005b52' }, width: '40px', marginRight: "15px" }}
                            value={addPalletCount}
                            size="medium"
                            onChange={(event) => {
                                if (event.target.value === '') {
                                    setAddPalletCount(1);
                                }
                                else {
                                    let tmp = parseInt(event.target.value, 10)
                                    if (!isNaN(tmp)) {
                                        setAddPalletCount(tmp);
                                    }
                                }
                            }}
                            inputProps={{
                                // step: 1,
                                // min: 0,
                                // type: 'number',
                                'aria-labelledby': 'input-count',
                            }}
                        />
                        <Button
                            onClick={() => addBox()}
                            variant="contained"
                            size="medium"
                            sx={{
                                textTransform: "none",
                                fontWeight: "bold",
                                px: 3,
                                width: "200px"
                            }}
                        >
                            Добавить паллеты
                        </Button>
                    </div>
                  </div>
              </div>
              <div style={{width: "40%", display: 'flex', flexDirection: 'column', alignItems: "center"}}>
                  <Typography
                    variant="body1"
                    sx={{
                        fontWeight: "bold",
                        color: "text.primary",
                    }}
                  >
                    Распределенные товары
                  </Typography>
                  <Scrollbars
                    style={{height: "480px"}}
                  >
                    {boxes.filter((fel) => fel.type === "pallet").map((parel, index) => (
                      <>
                          <ListItemButton sx={{width: "100%", height: "60px"}}>
                              <div style={{ width: '100%', display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                  <div style={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                      {/* <ListItemText primary={el.id} /> */}
                                      <Typography variant='subtitle2' align='left' style={{ fontWeight: 'bold' }}>{parel.title}</Typography>
                                  </div>
                                  <div
                                      style={{display: 'flex', flexDirection: 'column'}}
                                  >
                                      <Typography sx={{lineHeight: "10px", fontSize: "10px", marginLeft:"10px"}}>Адрес хранения</Typography>
                                      <DropdownMenu 
                                          data={addrs} 
                                          onChange={(e) => handleInputChangeAddr(parel.id, e)}  
                                          startVal={parel.addr}
                                          defText={"Выбрать ячейку"}
                                      />
                                  </div>
                              </div>
                          </ListItemButton>
                      </>
                    ))}
                  </Scrollbars>
              </div>
            </div>
        </Box>
    );
}